// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

Vue.config.productionTip = false

//cnzz
import "@/assets/js/cnzz.js"

//样式重置
import "@/assets/css/reset.css"

//定义moment全局日期过滤器
import Moment from "moment"
Moment.locale("zh-cn")
//修改时间格式，如“YYYY-DD-MM”
Vue.filter('convertTime', function(data, formatStr) {
	return Moment(data).format(formatStr);
})
//修改时间格式为倒计时
Vue.filter('relativeTime', function(data) {
	return Moment(data).fromNow();
})
//时间戳转时间格式
Vue.filter('toDateTime', function(data) {
	return Moment.unix(data);
})

//全局注册mint-ui组件
import "mint-ui/lib/style.css"
import Mint from "mint-ui"
Vue.use(Mint)

//配置Axios
import Axios from "axios"
import qs from 'qs';
//配置公共URL
Axios.defaults.baseURL = "http://api.yushuiyuan.cn/api/"

Axios.defaults.timeout = 30000;
Vue.prototype.$axios = Axios

//配置请求拦截器，显示loading
Axios.interceptors.request.use(
	config => {
		Mint.Indicator.open({
			text: "加载中"
		});
		if(config.url=="My/AddRealnameAuthentication"||config.url=="Dynamic/ReleaseDynamic"||config.url=="User/register"||config.url=="My/AddEducationAuthentication"||config.url=="My/AddHouseAuthentication"||config.url=="My/AddVehicleAuthentication"||config.url=="Appointment/Appointment"||config.url=="Currency/UserFeedback"||config.url=="User/UpdateAvatar"){
			config.headers = {
				'Content-Type': 'multipart/form-data'
			}
		}else{
			config.headers = {
				'Content-Type': 'application/x-www-form-urlencoded',
			}
			config.transformRequest = [data => qs.stringify(data)];
		}
		
		
		for(var i in config.data) {
			var value = config.data[i];
			if(value === '' || value === null || value === undefined) {
				delete config.data[i];
			} else {}
		}
		return config;
	},
	error => {
		Mint.Indicator.close();
		return config;
	}
)
//配置响应拦截器，显示loading
Axios.interceptors.response.use(function(response) {
	Mint.Indicator.close();
	return response;
})

//全局引入图片预览组件
import VuePreview from "vue2-preview"
Vue.use(VuePreview,{
  mainClass: 'pswp--minimal--dark',
  barsSize: {top: 0, bottom: 0},
  captionEl: false,
  fullscreenEl: false,
  shareEl: false,
  bgOpacity: 0.85,
  tapToClose: true,
  tapToToggleControls: false
});

//判断是否登录
Vue.prototype.isLogin = function (){
	let id = this.getCookie("yushuiyuanid")||this.getLocalStorage("yushuiyuanid")||this.$store.state.UserId;
	let add = this.getCookie("yushuiyuanadd")||this.getLocalStorage("yushuiyuanadd")||this.$store.state.nowAddress;
	this.$store.commit("getUserId", id);
	this.$store.commit("setNowAdd", add);
	let uid = this.$store.state.UserId;
	if(uid == ""||(typeof("uid")=="undefined"||null)){
		this.$toast({
			message: "未登录",
			position: "bottom",
			duration: 3000
		});
		return false;
	}else{
		return true;
	}
}


Vue.prototype.getCookie = function(name) { 
    var arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)");
 
    if(arr=document.cookie.match(reg))
 
        return unescape(arr[2]); 
    else 
        return null; 
}
Vue.prototype.getLocalStorage = function(name) { 
    return localStorage.getItem(name)
} 

//md5加密
import md5 from 'js-md5';
Vue.prototype.$md5 = md5;

/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	store,
	components: {
		App
	},
	template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js